const doneActionsOutput = {
  title: `Ações concluídas`,
  title1: `Ações Vencidas`,
  title2: `Ações a Vencer`
};

export default doneActionsOutput;
